import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';

export default function Navbar() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [isScrolled, setIsScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const navOptions = [
        {
            name: 'Home',
            path: '/home',
            svg: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon icon-tabler icon-tabler-home"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M5 12l-2 0l9 -9l9 9l-2 0" />
                    <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7" />
                    <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6" />
                </svg>
            ),
        },
        {
            name: 'About Us',
            path: '/about',
            svg: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon icon-tabler icon-tabler-question-mark"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M8 8a3.5 3.5 0 0 1 3.5 -3h1a3.5 3.5 0 0 1 3.5 3a3 3 0 0 1 -2 3a3 4 0 0 0 -2 4" />
                    <path d="M12 19l0 .01" />
                </svg>
            ),
        },
        {
            name: 'Products',
            path: '/products',
            svg: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon icon-tabler icon-tabler-components"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M3 12l3 3l3 -3l-3 -3z" />
                    <path d="M15 12l3 3l3 -3l-3 -3z" />
                    <path d="M9 6l3 3l3 -3l-3 -3z" />
                    <path d="M9 18l3 3l3 -3l-3 -3z" />
                </svg>
            ),
        },
        {
            name: 'Services',
            path: '/services',
            svg: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon icon-tabler icon-tabler-device-gamepad"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M9 12l-3 -3h-2a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h2z" />
                    <path d="M15 12l3 -3h2a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-2z" />
                    <path d="M12 15l-3 3v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1 -1v-2z" />
                    <path d="M12 9l-3 -3v-2a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v2z" />
                </svg>
            ),
        },
        {
            name: 'Brochures',
            path: '/brochures',
            svg: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon icon-tabler icon-tabler-book"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M3 19a9 9 0 0 1 9 0 9 9 0 0 1 9 0" />
                    <path d="M3 6a9 9 0 0 1 9 0 9 9 0 0 1 9 0" />
                    <path d="M3 6v13" />
                    <path d="M12 6v13" />
                    <path d="M21 6v13" />
                </svg>
            ),
        },
        {
            name: 'Contact Us',
            path: '/contactus',
            svg: (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon icon-tabler icon-tabler-address-book"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M20 6v12a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2z" />
                    <path d="M10 16h6" />
                    <path d="M13 11m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                    <path d="M4 8h3" />
                    <path d="M4 12h3" />
                    <path d="M4 16h3" />
                </svg>
            ),
        },
    ];

    const leftNavOptions = navOptions.slice(0, 3); // Home, About Us, Products
    const rightNavOptions = navOptions.slice(3); // Services, Brochures, Contact Us

    return (
        <>
            <div
                className={`fixed z-50 top-0 w-full text-black flex items-center justify-between px-5 sm:px-8 md:px-12 lg:px-16 xl:px-20 2xl:px-24 transition-all duration-300 ${
                    isScrolled ? 'bg-white shadow-md items-center md:h-16 h-16' : 'bg-[#ffffff] md:h-16 h-16'
                }`}
            >
                {/* Mobile Menu Button */}
                <button
                    className="lg:hidden text-black"
                    onClick={() => setIsSidebarOpen(true)}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="icon icon-tabler icon-tabler-menu-2"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M4 6l16 0" />
                        <path d="M4 12l16 0" />
                        <path d="M4 18l16 0" />
                    </svg>
                </button>

                {/* Mobile Logo */}
                <Link to="/home" className="lg:hidden">
                    <div className="logo w-36 h-12">
                        <img
                            src="/assets/NORTHERN_PROFESSIONAL_LOGO.png"
                            alt="logo"
                            className="w-full h-full object-contain"
                        />
                    </div>
                </Link>

                {/* Desktop Navigation */}
                <div className="hidden lg:flex items-center justify-between w-full">
                    {/* Left Navigation */}
                    <div className="flex gap-6 xl:gap-8 2xl:gap-10 text-indigo-900 text-[15px] xl:text-[17px] font-medium">
                        {leftNavOptions.map((option, index) => (
                            <div
                                key={option.name}
                                className="relative"
                                onMouseEnter={() => setActiveDropdown(index)}
                                onMouseLeave={() => setActiveDropdown(null)}
                            >
                                <Link
                                    to={option.path}
                                    className={`${
                                        location.pathname === option.path
                                            ? 'text-red-700 font-bold'
                                            : ''
                                    } hover:text-red-700 transition-colors duration-200 whitespace-nowrap`}
                                >
                                    {option.name}
                                </Link>
                                {activeDropdown === index && option.subOptions && (
                                    <div className="absolute top-full left-0 mt-2 w-48 bg-white shadow-lg rounded-md py-2 z-50">
                                        {option.subOptions.map((subOption) => (
                                            <Link
                                                key={subOption}
                                                to={`${option.path}/${subOption.toLowerCase().replace(' ', '-')}`}
                                                className="block px-4 py-2 text-black hover:bg-gray-100 hover:text-orange-500"
                                            >
                                                {subOption}
                                            </Link>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>

                    {/* Center Logo */}
                    <Link to="/home" className="flex justify-center mx-8 xl:mx-12 2xl:mx-16">
                        <div className="logo w-44 h-14 xl:w-52 xl:h-16 2xl:w-60 2xl:h-18">
                            <img
                                src="/assets/NORTHERN_PROFESSIONAL_LOGO.png"
                                alt="logo"
                                className="w-full h-full object-contain"
                            />
                        </div>
                    </Link>

                    {/* Right Navigation */}
                    <div className="flex gap-6 xl:gap-8 2xl:gap-10 text-indigo-900 text-[15px] xl:text-[17px] font-medium">
                        {rightNavOptions.map((option, index) => (
                            <div
                                key={option.name}
                                className="relative"
                                onMouseEnter={() => setActiveDropdown(index + 3)}
                                onMouseLeave={() => setActiveDropdown(null)}
                            >
                                <Link
                                    to={option.path}
                                    className={`${
                                        location.pathname === option.path
                                            ? 'text-red-700 font-bold'
                                            : ''
                                    } hover:text-red-700 transition-colors duration-200 whitespace-nowrap`}
                                >
                                    {option.name}
                                </Link>
                                {activeDropdown === index + 3 && option.subOptions && (
                                    <div className="absolute top-full left-0 mt-2 w-48 bg-white shadow-lg rounded-md py-2 z-50">
                                        {option.subOptions.map((subOption) => (
                                            <Link
                                                key={subOption}
                                                to={`${option.path}/${subOption.toLowerCase().replace(' ', '-')}`}
                                                className="block px-4 py-2 text-black hover:bg-gray-100 hover:text-orange-500"
                                            >
                                                {subOption}
                                            </Link>
                                        ))}
                                    </div>
                                )}
                            </div>
                                        ))}
                    </div>
                </div>
            </div>

            {/* Mobile Sidebar */}
            <div
                className={`fixed inset-0 z-50 bg-black bg-opacity-50 flex transition-all duration-300 ${
                    isSidebarOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
                }`}
                onClick={() => setIsSidebarOpen(false)}
            >
                <div
                    className={`bg-white w-[70%] max-w-sm h-full p-5 flex flex-col gap-5 transition-all duration-300 transform ${
                        isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
                    }`}
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="flex w-full justify-end">
                        <button
                            className="text-black"
                            onClick={() => setIsSidebarOpen(false)}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="icon icon-tabler icon-tabler-x"
                            >
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                    <div className="flex flex-col gap-3">
                        {navOptions.map((option) => (
                            <Link
                                to={option.path}
                                key={option.name}
                                className={`px-6 py-3 rounded-md flex gap-3 items-center transition-colors duration-200 ${
                                    location.pathname === option.path
                                        ? 'text-white bg-[#2947A9]'
                                        : 'text-black hover:bg-gray-50'
                                }`}
                                onClick={() => setIsSidebarOpen(false)}
                            >
                                {option.svg} {option.name}
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}